import { useCallback, useMemo } from 'react';
import {
	ToothPathology,
	ToothPathologyRootDecayValues,
} from '../../../../../graphql/graphql';

interface Props {
	pathology?: ToothPathology;
	setPathology: (pathology: ToothPathology) => void;
}

export default function useToothPathologyRootDecay({
	pathology,
	setPathology,
}: Props) {
	const setValues = useCallback(
		(values: ToothPathologyRootDecayValues) => {
			setPathology({
				...pathology,
				rootDecay: {
					...pathology?.rootDecay,
					surfaces: pathology?.rootDecay?.surfaces ?? [],
					values,
				},
			});
		},
		[pathology, setPathology],
	);

	return useMemo(
		() => ({
			rootDecay: {
				values: pathology?.rootDecay?.values,
				setValues,
			},
		}),
		[pathology],
	);
}
